module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Published in the United States in 2019 by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("CASEMATE PUBLISHERS")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("1950 Lawrence Road, Havertown, PA 19083")]), _vm._v(" "), _c('p', {
    staticClass: "copya"
  }, [_vm._v("and in the United Kingdom by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("OXBOW BOOKS")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The Old Music Hall, 106–108 Cowley Road, Oxford, OX4 1JE")]), _vm._v(" "), _c('p', {
    staticClass: "copya"
  }, [_vm._v("Hardcover Edition: ISBN 978-1-61200-810-3")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Digital Edition: ISBN 978-1-61200-811-0 (epub")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("eISBN 978-1-78925-185-2")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Mobi ISBN 978-1-78925-186-9")]), _vm._v(" "), _c('p', {
    staticClass: "copyaa"
  }, [_vm._v("First published as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Armee der Caesaren: Archäologie und Geschichte")]), _vm._v(" in 2012 (revised 2014) by Verlag Friedrich Pustet, Regensburg, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "copya"
  }, [_vm._v("Text © 2012, 2014 Thomas Fischer, Ronald Bockius, Dietrich Boschung and Thomas Schmidts")]), _vm._v(" "), _c('p', {
    staticClass: "copya"
  }, [_vm._v("Translation © 2017 M. C. Bishop")]), _vm._v(" "), _c('p', {
    staticClass: "copya"
  }, [_vm._v("English Language Edition © Oxbow Books 2019")]), _vm._v(" "), _c('p', {
    staticClass: "copyaa"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the publisher in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "copya"
  }, [_vm._v("For a complete list of Casemate titles, please contact:")]), _vm._v(" "), _c('p', {
    staticClass: "copyaa"
  }, [_vm._v("CASEMATE PUBLISHERS (US)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Telephone (610) 853-9131")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Fax (610) 853-9146")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Email: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:casemate@casematepublishers.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("casemate@casematepublishers.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.casematepublishers.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.casematepublishers.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copya"
  }, [_vm._v("CASEMATE PUBLISHERS (UK)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Telephone (01865) 241249")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Telephone (610) 853-9131, Fax (610) 853-9146")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Email: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:casemate-uk@casematepublishers.co.uk"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("casemate-uk@casematepublishers.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.casematepublishers.co.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.casematepublishers.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copyht"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Front cover:")]), _vm._v(" (Background) Rome, Trajan’s Column. (Foreground) Reconstructed Hebron type helmet (iron and copper alloy). Photo: J. Pogorzelski")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a3956a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Copyright.vue
// module id = 63
// module chunks = 0